import React, { useState, useContext, useEffect } from "react";
import Context from "../Context";
import Config from "../config.json";
import { useParams } from "react-router";
import { Row, Col, Card } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import DocumentMeta from "react-document-meta";
export default () => {
  const context = useContext(Context);
  const { access_token, expires_at } = useParams();
  const [loading, set_loading] = useState("not_loaded");
  const fetchProfile = () => {
    set_loading("loading");
    context.ApiDriver.access_token = access_token;
    context.ApiDriver.expires_at = expires_at;
    context.ApiDriver.fetchProfile(
      response => {
        context.cookie.set("pajoohyar_extention_access_token", access_token, {
          path: "/",
        });
        context.cookie.set("pajoohyar_extention_expires_at", expires_at, {
          path: "/",
        });
        // we have to reduce profile info length (cause of limitions in cookie
        // but I don't want to change the api. because maybe in the furure, these information would be needed)
        response.default_collection = { id: response.default_collection.id };

        context.cookie.set(
          "pajoohyar_extention_profile",
          JSON.stringify(response),
          {
            path: "/",
          },
        );
        set_loading("loaded");
      },
      error => {
        console.log(error);
        set_loading("loaded");
      },
    );
  };
  useEffect(fetchProfile, []);

  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: Config.title + " | تماس با ما",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  };
  if (loading === "not_loaded" || loading === "loading")
    return (
      <DocumentMeta {...page_meta}>
        <Row className="justify-content-center" style={{ minHeight: 550 }}>
          <Col>
            <Card style={{ marginTop: 150, marginBottom: 30 }}>
              <Card.Body style={{ margin: "auto" }}>
                در حال دریافت اطلاعات...
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </DocumentMeta>
    );
  return (
    <DocumentMeta {...page_meta}>
      <Row className="justify-content-center" style={{ minHeight: 550 }}>
        <Col>
          <Card style={{ marginTop: 150, marginBottom: 30 }}>
            <Card.Body style={{ margin: "auto" }}>
              <Col>
                <Row style={{ marginBottom: 20, justifyContent: "center" }}>
                  <FaCheckCircle size={40} color={"green"} />{" "}
                </Row>
                <Row>ورود به افزونه پژوهیار با موفقیت انجام شد.</Row>
              </Col>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </DocumentMeta>
  );
};
